import { render, staticRenderFns } from "./BrandMediaSidebarItem.vue?vue&type=template&id=d32e9d2a&scoped=true&"
import script from "./BrandMediaSidebarItem.vue?vue&type=script&lang=ts&"
export * from "./BrandMediaSidebarItem.vue?vue&type=script&lang=ts&"
import style0 from "./BrandMediaSidebarItem.vue?vue&type=style&index=0&id=d32e9d2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32e9d2a",
  null
  
)

export default component.exports